/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import { AppContext, RemoteDataActions, UidUtil } from 'plugin/liferay-widgets-react-web';
import ActionsTypesModal from '../constants/ActionsTypesModal';
import { loadModuleByClassName } from 'plugin/liferay-widgets-react-web';

export default {

    showModal: (className, query, isList = true, props = undefined, context = undefined, api = undefined, dataName) => {

        //Load Module ASYNC if not exists
        loadModuleByClassName( className , () => {
            dataName = dataName || UidUtil.generateId('modal_data') + '_data';
            if (isList) {
                RemoteDataActions.list(dataName, className, query, api);
            } else {
                RemoteDataActions.item(dataName, className, query, api);
            }
            AppContext.getDispatcher().dispatch({
                type: ActionsTypesModal.SHOW_MODAL,
                payload: {
                    dataName,
                    className,
                    props,
                    context
                },
                error: {},
                meta: {}
            });
        });
    },

    hideModal: (className, dataName) => {
        AppContext.getDispatcher().dispatch({
            type: ActionsTypesModal.HIDE_MODAL,
            payload: {
                dataName,
                className
            },
            error: {},
            meta: {}
        });
    }


}





// WEBPACK FOOTER //
// ./js/actions/ModalActions.js